module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av521-13ce3540c62e3838b66993a67dacd5e8.jpg";